<div class="container" *ngIf="!loadingPM && wallet">
  <div class="purchase__body py-6">
    <div class="purchase__details flex gap-10">
      <div class="flex-auto">
        <ng-container *ngFor="let step of steps; let i = index">
          <div class="flex flex-col gap-4" *ngIf="step.active">
            <div class="step__header flex items-center justify-between">
              <h3 class="spacer title" [style.fontWeight]="500">{{ step.id.toString() | titlecase }}</h3>
              <div class="flex items-center content-center gap-2">
                <span
                  *ngFor="let item of steps; let ix = index"
                  [ngClass]="i === ix ? 'bg-sky-500 text-white' : 'bg-gray-400'"
                  class="step-index"
                >
                  {{ ix + 1 }}
                </span>
              </div>
            </div>
            <mat-divider></mat-divider>
            <psh-select-number-product
              *ngIf="step.id === stepName.number && step.active"
              [numberSkuMapping]="numberSkuMapping"
              [organization]="organization"
              [saleModel]="saleModel"
              [sku]="sku"
              [productId]="product.productId"
              [purchaseAddonModel]="purchaseAddonModel"
              [numberVendor]="numberVendor"
              (changeNumberSkuMapping)="changeNumberSkuMapping($event)"
              (changeNumberVendor)="changeNumberVendor($event)"
              (changeLoadingNumber)="changeLoadingNumber($event)"
            ></psh-select-number-product>
            <psh-payment
              *ngIf="step.id === stepName.checkout && step.active"
              [totalPrice]="totalPrice"
              [wallet]="wallet"
              [totalActivationFee]="totalActivationFee"
              [hasNumber]="hasNumber"
              [hasTrial]="hasTrial"
              [productName]="product.name"
              [(autoRenew)]="autoRenew"
              (changeProductQuantity)="changeProductQuantity($event)"
              (changeTrial)="changeTrial()"
            ></psh-payment>
          </div>
        </ng-container>
      </div>
      <mat-card class="summary basis-[300px] justify-between">
        <img class="w-12" src="portal/assets/images/subscriptions.svg" alt="compilation-success" />
        <h3>SUMMARY</h3>
        <p>
          - You're purchasing plan
          <strong>{{ sku.name }}</strong>
          of
          <strong>{{ product.name }}</strong>
          <span *ngIf="trial">
            in
            <strong>trial</strong>
            mode.
          </span>
        </p>
        <p *ngIf="autoRenew">- System will renew your subscription <strong>7</strong> days before the expiry date.</p>
      </mat-card>
    </div>
  </div>

  <div class="purchase__actions flex gap-10 justify-end">
    <div class="flex-auto flex justify-between items-center">
      <ng-container *ngIf="activeStep === stepName.checkout">
        <button mat-stroked-button (click)="back()">
          <mat-icon *ngIf="steps.length > 1">arrow_back</mat-icon>
          {{ steps.length > 1 ? 'Back' : 'Cancel' }}
        </button>
        <ng-container *ngIf="wallet && (wallet.usableCredit >= totalPrice || totalPrice === 0); else topUp">
          <button mat-flat-button color="primary" [disabled]="isProductPaymentDisabled" (click)="payment()">
            {{ trial ? 'Trial' : 'Pay now' }}
          </button>
        </ng-container>
        <ng-template #topUp>
          <button mat-raised-button color="primary" (click)="openTopup()">Topup</button>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="activeStep === stepName.number && !loadingNumber">
        <div class="flex justify-between flex-grow">
          <button mat-stroked-button (click)="cancel()">Cancel</button>
          <button mat-flat-button color="primary" (click)="next()">Next</button>
        </div>
      </ng-container>
    </div>
    <div class="basis-[300px]"></div>
  </div>
</div>
